import { motion, AnimatePresence, useIsPresent} from 'framer-motion';
import React, { useEffect, useState, useRef } from 'react';
import { UserAvatar } from './SkepticParts';
import { get_member_data } from '../api/api_calls';

function SearchIcon(){
  return(    
          <svg className="fill-black dark:fill-skeptic-foreground-dark size-7 " viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_297_4740" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={25}>
              <rect y="0.757812" width={24} height={24} fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_297_4740)">
              <path d="M19.6 21.7578L13.3 15.4578C12.8 15.8578 12.225 16.1745 11.575 16.4078C10.925 16.6411 10.2333 16.7578 9.5 16.7578C7.68333 16.7578 6.14583 16.1286 4.8875 14.8703C3.62917 13.612 3 12.0745 3 10.2578C3 8.44115 3.62917 6.90365 4.8875 5.64531C6.14583 4.38698 7.68333 3.75781 9.5 3.75781C11.3167 3.75781 12.8542 4.38698 14.1125 5.64531C15.3708 6.90365 16 8.44115 16 10.2578C16 10.9911 15.8833 11.6828 15.65 12.3328C15.4167 12.9828 15.1 13.5578 14.7 14.0578L21 20.3578L19.6 21.7578ZM9.5 14.7578C10.75 14.7578 11.8125 14.3203 12.6875 13.4453C13.5625 12.5703 14 11.5078 14 10.2578C14 9.00781 13.5625 7.94531 12.6875 7.07031C11.8125 6.19531 10.75 5.75781 9.5 5.75781C8.25 5.75781 7.1875 6.19531 6.3125 7.07031C5.4375 7.94531 5 9.00781 5 10.2578C5 11.5078 5.4375 12.5703 6.3125 13.4453C7.1875 14.3203 8.25 14.7578 9.5 14.7578Z"  />
            </g>
          </svg>
  )
}

function SubscribeButton(){
  return(    
    <button type="button" className="z_btn z_btn_primary">
      <span>{window.is_member ? 'Account' : 'Subscribe'}</span>
      <svg className="size-6 ml-1" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_298_3874" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={25}>
          <rect y="0.5" width={24} height={24} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_298_3874)">
          <path d="M11 13.5H5V11.5H11V5.5H13V11.5H19V13.5H13V19.5H11V13.5Z" fill="white" />
        </g>
      </svg>
    </button>
  )
}

function TwitterIcon(){
  return(
    <svg className="fill-src-dark-blue group-hover:fill-src-primary transition-all" width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.751 3.5H20.818L14.118 11.125L22 21.5H15.828L10.995 15.207L5.464 21.5H2.394L9.561 13.345L2 3.5H8.328L12.698 9.252L17.751 3.5ZM16.675 19.672H18.375L7.404 5.232H5.58L16.675 19.672Z" />
    </svg>
  )
}

function FacebookCircleIcon(){
  return(
    <svg className="fill-src-dark-blue group-hover:fill-src-primary transition-all" width={26} height={26} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ic:baseline-facebook">
        <path id="Vector" d="M23.8327 13.0003C23.8327 7.02033 18.9793 2.16699 12.9993 2.16699C7.01935 2.16699 2.16602 7.02033 2.16602 13.0003C2.16602 18.2437 5.89268 22.6095 10.8327 23.617V16.2503H8.66602V13.0003H10.8327V10.292C10.8327 8.20116 12.5335 6.50033 14.6243 6.50033H17.3327V9.75033H15.166C14.5702 9.75033 14.0827 10.2378 14.0827 10.8337V13.0003H17.3327V16.2503H14.0827V23.7795C19.5535 23.2378 23.8327 18.6228 23.8327 13.0003Z" />
      </g>
    </svg>
  )
}

const DarkModeSwitcher = () => {
  //We might change this to some fancy switcher later!!!
  const [switchTo, setSwitchTo] = useState('Mode');
  
  function updateSwitchToMode() {
    if (document.documentElement.classList.contains('dark')) {
        setSwitchTo('Light Mode');
    } else {
        setSwitchTo('Dark Mode');
    }
  }

  const handleClick = () => {
    console.log('[+] Switching mode...');
    if(document.documentElement.classList.contains('dark')){
        document.documentElement.classList.remove('dark');
        localStorage.theme = 'light';
    }else{
        document.documentElement.classList.add('dark');
        localStorage.theme = 'dark';
    }
  };

  useEffect(()=>{
     // Observe changes to the HTML class attribute
    const observer = new MutationObserver(() => {
      updateSwitchToMode();
    });
  
    observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
    });
  
    updateSwitchToMode();
  })

  return(
    <div className='flex items-center cursor-pointer group' onClick={handleClick}>
    <span className='group-hover:text-skeptic-primary'>{switchTo}</span>
    </div>
  )

}

function MobileNav(){
    const [isOpen, setIsOpen] = useState(false);
    const [navItems, setNavItems] = useState([]);
    const [isMember, setIsMember] = useState(0); //0,1,2 Anonymous, Free member, Paid member
    const [memberData, setMemberData] = useState({name:'John Doe', avatar: null});
    const [error, setError] = useState(null);

    const fetch_member_data = async() => {
      console.log('[+] Getting member data run...')
      try{
        let res = await get_member_data();
        const avatar_img = res.avatar_image;
        const name = res.name ?? 'John Doe';
        setMemberData({name: name, avatar: avatar_img});
      }catch(err){
        console.log('[X] Error in get member data -> ', err.message);
        setError(err.message);
        //setLoading(false);
      }
    }



    useEffect(()=>{
        const handleOpenMenu = async(event) => {
            console.log('[+] Handle open Mobile menu run...'); 
            console.log('[+] is member level ', isMember)
            const member_level = window.skp_member_level || 0;
            setIsMember(member_level);
            let action = event.detail.action;
            //why this does not reflect that member_level is 2
            if(member_level > 0){
              await fetch_member_data();
            }
            handleOpen(action);
        };
        const main_navigation = document.getElementById('main_nav');
        const li_items = main_navigation.querySelectorAll('li');
        
        let nav_items = [];
        for(let item of li_items){
            const a_href = item.querySelector('a').href;
            const a_title = item.querySelector('a').innerText || item.querySelector('a').children[0].innerText;
            const is_current = item.classList.contains('nav-current');
            nav_items.push({title:a_title, href:a_href, active:is_current});
        }

        setNavItems(nav_items);


        window.addEventListener('openNoiseMobileMenu', handleOpenMenu);

        return () => {
            window.removeEventListener('openNoiseMobileMenu', handleOpenMenu);
        };
    }, []);


    const containerVariants = {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: {
          duration: 0.3, // Adjust this for the fade-in duration
          ease: "easeInOut", // Smooth easing for entry
          staggerChildren: 0.07, // Adds stagger effect for entry animations
        },
      },
      exit: {
        opacity: 0,
        transition: {
          duration: 0.1, // Adjust this for the fade-out duration
          ease: "easeInOut", // Smooth easing for exit
          when: "afterChildren", // Ensures children exit animations complete first
          staggerChildren: 0.01,
          staggerDirection: -1, // Reverse order for exit stagger
        },
      },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: -10 },
        visible: { opacity: 1, y: 0 },
        exit: { opacity: 0 },
      };

    const secondUlVariants = {
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            delay: navItems.length * 0.07, // Calculate delay based on first ul's animation
            duration: 0.4, // Duration for fade-in
          },
        },
        exit: { opacity: 0, transition: { duration: 0.2 } },
    };

    const handleOpen = (action) =>{
      if(action){
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        setIsOpen(true);
      }
    }

     const handleClose = () => {
        setIsOpen(false);
        document.getElementsByTagName('body')[0].style.overflow = '';
     }

     //let nav_items = [...navItems, {title:'Subscribe', href:'#', active:false}];
  //if(!isOpen) return;
  //console.log('[+] Member level before render ', isMember);
  return (

      <AnimatePresence>
        {isOpen && (
          <>
          <motion.div
            className="fixed overflow-y-auto pb-20 flex-col top-0 left-0 w-full h-screen bg-skeptic-background dark:bg-skeptic-background-dark z-[990] flex items-end"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            key={`modal-1`}
            
          >
            {isMember > 0 ? (
            <div className='w-full px-5 cursor-pointer' onClick={()=> window.dispatchEvent( new CustomEvent('openUserAccountModal', { detail: { } } ))}>
              <div className="w-full  rounded-md flex justify-center mt-24 bg-skeptic-gray dark:bg-skeptic-gray-dark py-4">
                <div className='flex items-center'>
                  <UserAvatar className={'size-[3.25rem]'} remoteImageUrl={memberData.avatar}/>
                  <div className='flex flex-col ml-[--gap-11]'>
                    <h5 className='text-xs uppercase text-skeptic-charcoal dark:text-skeptic-foreground-dark'>Currently Signed In:</h5>
                    <div className='flex items-center mt-0.5'>
                      <h3 className='text_20 text-skeptic-charcoal dark:text-skeptic-foreground-dark'>{memberData.name}</h3>
                      <svg id="Regular" className='size-3 ml-1 mb-1' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path className="fill-skeptic-charcoal dark:fill-skeptic-foreground-dark" d="M23.25,7.311,12.53,18.03a.749.749,0,0,1-1.06,0L.75,7.311" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            ) : null}
            <motion.ul 
            className={`w-full list-none flex flex-col text_22 tracking-wide ml-0 ${isMember > 0 ? 'mt-7' : 'pt-28 min-[400px]:pt-36'} pb-7 px-[3.6vmin] text-right`}
            variants={containerVariants} // Apply stagger here
            key={`ul-1`}
            >           
              {navItems.map((el, index) => {
                return(
                <motion.li 
                key={`${el.title}-${index}`} 
                variants={itemVariants}      
                className={`text-skeptic-charcoal dark:text-skeptic-foreground-dark py-3 border-t border-black border-opacity-5 dark:border-white dark:border-opacity-5 ${el.active ? 'nav-current' : ''}`}          
                >
                  <a href={el.href}>{el.title}</a>
                </motion.li>
              )})}
            </motion.ul>
            
            <div className='w-full px-[3.6vmin]'>
            <motion.ul 
            variants={secondUlVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className='list-none border-t border-black dark:border-white uppercase w-full grid grid-cols-2 justify-end gap-y-5 pt-7'
            >
                <motion.li className={`${isMember > 0 ? 'hidden' : ''} text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark`}>
                  <a onClick={() => window.dispatchEvent( new CustomEvent('skpopenloginform', { detail: {}} ))}>
                    Log In
                  </a>
                </motion.li>
                <motion.li className={`${isMember > 0 ? 'hidden' : ''} text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark`}>
                  <a onClick={() => window.dispatchEvent( new CustomEvent('openModalPricingCards', { detail: {}} ))}>
                    Subscribe
                  </a>
                </motion.li>
                <motion.li className='text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark'>
                  <a href='/donate' alt="Link to donation page">
                    Donate
                  </a>
                </motion.li>
                <motion.li className='text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark'>
                  <a href='https://shop.skeptic.com/' alt="external link to skeptic magazine eshop">
                    Shop
                  </a>
                </motion.li>
                <motion.li className='text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark'>
                  <a onClick={() => window.dispatchEvent( new CustomEvent('alpinealgoliabox', { detail: {}} ))} className='flex items-center'>
                   <SearchIcon/> <span>Search</span>
                  </a>
                </motion.li>
                <motion.li className='text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark '>
                  <DarkModeSwitcher/>
                </motion.li>
                <motion.li className='text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark '>
                  <a href='/advertising' className='flex items-center'>
                   Advertising
                  </a>
                </motion.li>
                <motion.li className='text_20 flex justify-end text-skeptic-charcoal dark:text-skeptic-foreground-dark '>
                  <a href='/pitch-an-article' className='flex items-center'>
                   Pitch an Article
                  </a>
                </motion.li>
            </motion.ul>
            </div>

            <div onClick={handleClose} className="flex justify-end absolute top-0 left-0 w-full pt-10 pr-[3.6vmin]">
                <div className="hamburger hamburger--squeeze is-active">
                    <div className="hamburger-box">
                    <div className="hamburger-inner bg-black before:bg-black after:bg-black dark:bg-skeptic-foreground-dark  dark:before:bg-skeptic-foreground-dark  dark:after:bg-skeptic-foreground-dark "></div>
                    </div>
                </div>
            </div>
          </motion.div>
          </>
        )}
      </AnimatePresence>

  );
}

export default MobileNav;